import { render, staticRenderFns } from "./PowerTranslateMain.vue?vue&type=template&id=15d31775&scoped=true"
import script from "./PowerTranslateMain.vue?vue&type=script&lang=js"
export * from "./PowerTranslateMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d31775",
  null
  
)

export default component.exports